import React, { useRef, useEffect } from "react";
import { arrayOf, node, oneOfType, string, number } from "prop-types";

import ContentWrapper from "../../../shared/ContentWrapper";
import { useMap } from "@shared/v2/widgets/useMap";
import { googleMapsStyle } from "@lib/googleMapsStyle";

const TestDriveProgressLayout = ({
  geoLatitude,
  geoLongitude,
  markerImageUrl,
  children,
}) => {
  const mapContainerRef = useRef(null);

  const map = useMap({
    containerRef: mapContainerRef,
    options: {
      zoom: 12,
      center: { lat: Number(geoLatitude), lng: Number(geoLongitude) },
      options: {
        disableDefaultUI: false,
      },
      styles: googleMapsStyle,
    },
  });

  useEffect(() => {
    if (!map) {
      return;
    }

    const mapMarker = map.createMarker({
      position: { lat: Number(geoLatitude), lng: Number(geoLongitude) },
      icon: {
        url: markerImageUrl,
        scaledSize: new map.maps.Size(35, 35),
      },
    });

    map.render(mapMarker);

    return () => {
      map.remove(mapMarker);
    };
  }, [map, geoLatitude, geoLongitude, markerImageUrl]);

  return (
    <ContentWrapper className="md:px-0">
      <div className="grid grid-template-testdrive w-full gap-y-8">
        <div className="grid-area-map w-full relative max-lg:hidden">
          <div className="sticky top-30">
            <div className="w-screen h-150 relative lg:w-full lg:h-[calc(100dvh-7.5rem)]">
              <div
                className="w-screen h-150 lg:w-full lg:h-[calc(100dvh-7.5rem)]"
                ref={mapContainerRef}
              />
            </div>
          </div>
        </div>
        <div className="grid-area-title p-4 lg:px-8">{children}</div>
      </div>
    </ContentWrapper>
  );
};

TestDriveProgressLayout.propTypes = {
  geoLatitude: oneOfType([string, number]).isRequired,
  geoLongitude: oneOfType([string, number]).isRequired,
  children: oneOfType([node, arrayOf(node)]),
  markerImageUrl: string,
};

export default TestDriveProgressLayout;
